import React from 'react';
import VindimaAutorização from '../../components/VidimaModule/vindima_Autorização_component';

import NavBar from '../../components/common/navbar';
import SideBar from '../../components/modules/left_sidebar';
const queryString = require('query-string');
const Administration = false;
/*
Formato de solicitação padrão para todas as APIs de listagem   
*/
const listdefaultRequest = { "Filters": null, "SortBy": "", "IsSortTypeDESC": false, "IsPagination": false, "Page": 1, "PageSize": 100 }

/* Array de configurações estáticas da página*/
const optionMenuArray = [
    {
        main: "Autorização de produção",
        sub_menu: [
            {
                display: "-Autorização de produção",
                linkData: {
                    filters: {
                        Tabs: {
                            Autorização: [
                                {
                                    key: 'n_cartas_CartasA',
                                    displayKey: "Tipo de Carta",
                                    inputType: "radio"
                                },
                                {
                                    key: 'n_cartas_CartasB',
                                    displayKey: "Numero da Carta",
                                    inputType: "text"
                                }
                            ],
                            Datas:[
                                {
                                    key: 'date',
                                    displayKey: "Data de criação",
                                    inputType: "date"
                                },
                            ]
                        },
                        checkbox: [
                            {
                                key: 'n_cartas_CartasA',
                                displayKey: "Cartas A",
                                inputType: "radio"
                            },
                            {
                                key: 'n_cartas_CartasB',
                                displayKey: "Cartas B",
                                inputType: "radio"
                            },
                        ]
                    },
                    columnkeyMap: {
                        "n_cartas_CartasA": "Cartas A",
                        "valor_CartasA": "valor Cartas A",
                        "n_cartas_CartasB": "Cartas B",
                        "valor_CartasB": "valor Cartas B",
                        "n_cartas_Contratos": "Contratos",
                        "valor_Contratos": "valor Contratos",
                    },
                    actionbuttons: { Edit: false, Redirect: false, Delete: false },
                    listApilink: "/Vindima/ProducerAccount/GetAll",
                    listdefaultRequest: listdefaultRequest,
                    requestMethod: "post",
                    navbarOptionsYear: true,
                    TitleBarButtonName: "+ nova autorização",
                    TitleBarpath: "/vindima_authorizacao",
                    TitleBartitle: "Autorização de Produção",
                    TitleBarlogo: "auditing",
                    TabName: [],
                    notAction: true,
                    groupfield: [
                        { field: "Contratos" },
                        { field: "Cartas A" },
                        { field: "Cartas B" }
                    ]
                }
            }
        ]
    }
]


class VindimaAutorizacaoPage extends React.Component {
    /* Primeiro passo na acomodação da classe */
    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod()
    }
    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        this.setState(this.setLinkDataMethod())
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (prevProps) => {
        let parsed = this.props.location.state && this.props.location.state || {};
        let prevParsed = prevProps.location.state && prevProps.location.state || {}
        if (prevParsed.date !== parsed.date) {
            this.setState(this.setLinkDataMethod())
        }
    }

    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */
    setLinkDataMethod = () => {
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
        if (topBarMenu) {
            this.setState({ topBarMenu })
        }
        const parsed = this.props.location.state && this.props.location.state.paramoption || {};
        let mainIndex = 0;
        let subIndex = 0;
        if (parsed.m) {
            mainIndex = parsed.m;
        }
        if (parsed.s) {
            subIndex = parsed.s;
        }
        let selectOption = optionMenuArray[mainIndex].sub_menu[subIndex];
        let selectedMainOption = optionMenuArray[mainIndex]
        let year = new Date();
        year = year.getFullYear();
        return {
            year: year,
            selectedtitelotion: selectOption.display,
            selectedMainOption: selectedMainOption.main,
            linkData: selectOption.linkData
        }
    }

    /*  Sempre que o usuário alterar qualquer opção do front end, este método irá atualizar o url da página de acordo com essa opção  */
    changeOption = (mainIndex, subIndex) => {
        this.props.history.push({
            pathname: "/vindima_authorizacao",
            state: {
                topBarMenu: this.state.topBarMenu,
                paramoption: {
                    m: mainIndex,
                    s: subIndex
                },
                date: new Date()
            }
        })
        return;
    }

    /*  Usado para alterar o ano da página completa e filtrar os dados de acordo  */
    updateYear = (year) => {
        this.setState({
            year: year
        })
    }

    /*  Para renderizar o conteúdo html da página   */
    render() {
        return (
            <div className="dashboard">
                <NavBar date={new Date()}
                 optionMenuArray={optionMenuArray} 
                 changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)} 
                 linkData={this.state.linkData} 
                 selectedtitelotion={this.state.selectedtitelotion}
                 topBarMenuOption={this.state.topBarMenu} 
                 year={this.state.year} 
                 updateYear={(year) => this.updateYear(year)} />
                 
                <SideBar Administration={Administration} />
                <div className="container-fluid">
                    <VindimaAutorização selectedMainOption={this.state.selectedMainOption} date={new Date()} year={this.state.year} changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)} optionMenuArray={optionMenuArray} linkData={this.state.linkData} selectedtitelotion={this.state.selectedtitelotion} />
                </div>
            </div>
        )
    }
}



export default VindimaAutorizacaoPage;